var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 66.91 66.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed7850;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #f2f2f2;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 33.45,
    cy: 33.45,
    r: 33.45,
    transform: "translate(-3.68 4.14) rotate(-6.72)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.46,
    y1: 33.78,
    x2: 15.36,
    y2: 33.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "35.22 53.96 15.04 33.78 36.08 12.75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowI);
export default __webpack_public_path__ + "static/media/arrowI.756ba7c4c72b9f0d2bf118f67476db69.svg";
export { ForwardRef as ReactComponent };